var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "ruleForm",
    staticStyle: {
      "padding": "0 10%"
    },
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "组织架构",
      "prop": "organize_ids"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "margin-left": "1px",
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    model: {
      value: (_vm.ruleForm.organize_ids),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "organize_ids", $$v)
      },
      expression: "ruleForm.organize_ids"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "岗位",
      "prop": "post_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-left": "1px",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择岗位",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.post_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "post_id", $$v)
      },
      expression: "ruleForm.post_id"
    }
  }, _vm._l((_vm.postList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.post_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "计算方式",
      "prop": "calculation_method"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.calculation_method),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "calculation_method", $$v)
      },
      expression: "ruleForm.calculation_method"
    }
  }, _vm._l((_vm.countList), function(calculation_method) {
    return _c('el-radio', {
      key: calculation_method.id,
      attrs: {
        "label": calculation_method.type,
        "value": calculation_method.id
      }
    }, [_vm._v(_vm._s(calculation_method.name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "30%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425641dc","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gzhsgl/Jsfs/jsfs_add.vue
// module id = null
// module chunks = 